// DEMO: iframe overlay on video — remove this entire file when done

const STORAGE_KEY = 'LD_OVERLAY'

export function installOverlayRouterGuard(router) {
  router.beforeEach((to, from, next) => {
    const query = to.query
    const hasOverlayParams = query.ld_overlay_nuke || query.ld_overlay_url

    if (hasOverlayParams) {
      if (query.ld_overlay_nuke) {
        localStorage.removeItem(STORAGE_KEY)
      } else if (query.ld_overlay_url) {
        const overlay = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{"global":null,"patients":{}}')
        const config = {
          url: query.ld_overlay_url,
          height: parseInt(query.ld_overlay_height) || 80
        }
        if (query.ld_overlay_patient_id) {
          overlay.patients = overlay.patients || {}
          overlay.patients[String(query.ld_overlay_patient_id)] = config
        } else {
          overlay.global = config
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(overlay))
      }

      const cleanQuery = { ...query }
      delete cleanQuery.ld_overlay_url
      delete cleanQuery.ld_overlay_height
      delete cleanQuery.ld_overlay_patient_id
      delete cleanQuery.ld_overlay_nuke
      return next({ path: to.path, query: cleanQuery, hash: to.hash, replace: true })
    }

    next()
  })
}

export function resolveOverlayConfig(patientId) {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    const overlay = JSON.parse(raw)
    const pid = String(patientId || '')
    if (pid && overlay.patients?.[pid]) return overlay.patients[pid]
    if (overlay.global) return overlay.global
  } catch (e) {
    console.warn('Failed to parse LD_OVERLAY', e)
  }
  return null
}

export function buildOverlayIframeSrc(config, patientId, monitorId) {
  if (!config?.url) return null
  try {
    const url = new URL(config.url)
    if (patientId) url.searchParams.set('patient_id', patientId)
    if (monitorId) url.searchParams.set('monitor_id', monitorId)
    return url.toString()
  } catch {
    return config.url
  }
}
